module.exports = __webpack_public_path__ + "img/content7-4.f06ce82c.png";